/**
 * 管理后台布局组件
 *
 * 左侧深色导航栏 + 右侧内容区
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';

const AdminLayout: React.FC = () => {
    return (
        <div style={{ display: 'flex', height: '100vh', width: '100vw' }}>
            <AdminSidebar />
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#f8f9fa',
                    overflow: 'hidden',
                }}
            >
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
